import { useEffect, useMemo } from "react"

import { useLazyGetAdminDevicesQuery } from "store/api/adminApi"
import { useLazyGetAdminMessageDevicesQuery } from "store/api/adminMessagesApi"
import { UITypes } from "types"

import { combineAdminDevicesWithMessages, getAdminDeviceSearchParams } from "./adminMessageUtils"

export const useAdminDeviceMessages = (queryParams: UITypes.Params) => {
  const deviceSearchParams = useMemo(() => getAdminDeviceSearchParams(queryParams), [queryParams])
  const [getAdminDevices, adminDevicesQuery] = useLazyGetAdminDevicesQuery()
  const [getAdminMessageDevices, adminMessagesQuery] = useLazyGetAdminMessageDevicesQuery()
  const matchingDevices = adminDevicesQuery.currentData?.data || []
  const deviceIds = useMemo(() => matchingDevices.map(device => device.id), [matchingDevices])

  useEffect(() => {
    getAdminDevices(deviceSearchParams)
  }, [deviceSearchParams, getAdminDevices])

  useEffect(() => {
    if (adminDevicesQuery.currentData && deviceIds.length > 0) {
      getAdminMessageDevices({ device_ids: deviceIds })
    }
  }, [adminDevicesQuery.currentData, deviceIds, getAdminMessageDevices])

  return {
    devices: combineAdminDevicesWithMessages(matchingDevices, adminMessagesQuery.currentData?.data || []),
    meta: adminDevicesQuery.currentData?.meta,
    isLoading: adminDevicesQuery.isFetching || adminMessagesQuery.isFetching,
    isError: adminDevicesQuery.isError || adminMessagesQuery.isError,
  }
}
